module.exports = __webpack_public_path__ + "img/door7.648c08ec.png";